import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AddObservationValue from "./AddObservationValue";
import AddObservationValueFullScreen from "./AddObservationValueFullScreen";
import UploadDocument from "./UploadDocument";
import { MODALS } from "utils/constants";
import Modal from "components/Common/Modal";
import { resetResultEntryObservations } from "../../../redux/action/result_entry_observation_action";
import { useDispatch } from "react-redux";

const AddObservationValuePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [documentModal, setDocumentModal] = useState(false);
  // const [documentInfo, setdocumentInfo] = useState();

  const [rowDataForObservation, setRowDataForObservation] = useState(
    location.state?.rowData || null
  );
  const [documentInfo, setDocumentInfo] = useState(
    location.state?.documentInfo || null
  );

  const onObservationValueClose = (shouldRefetch = false) => {
    dispatch(resetResultEntryObservations());

    if (shouldRefetch && location.state?.refetchBussinessReport) {
      location.state.refetchBussinessReport();
    }

    navigate(-1);
  };

  // const handleDocuments =
  //   location.state?.handleDocuments ||
  //   ((docs) => {
  //     console.log("Documents:", docs);
  //   });

  const handleDocuments = useCallback((data, e) => {
    setDocumentModal(true);
  }, []);

  const onClose = () => {
    setDocumentModal(false);
  };

  useEffect(() => {
    if (!rowDataForObservation) {
      console.error("No row data found, redirecting back");
      navigate(-1);
    }
  }, [rowDataForObservation, navigate]);

  if (!rowDataForObservation) {
    return (
      <div className="observation-entry-page">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <div>Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-3">
      <div className="row mb-3">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <h4 className="fs-5 mb-0">Patient LAB Result Entry</h4>
            <button
              className="btn btn-secondary btn-sm"
              onClick={() => onObservationValueClose(false)}
              type="button"
            >
              ← Back
            </button>
          </div>
        </div>
      </div>

      <Modal
        type="modal-lg"
        show={documentModal}
        onHide={() => setDocumentModal(false)}
        modalName={MODALS.ADD_MODAL}
        title={"Upload File"}
        body={
          <UploadDocument
            rowData={rowDataForObservation}
            onClose={onClose}
            setdocumentInfo={setDocumentInfo}
            setDocumentModal={setDocumentModal}
            // setIsOpenObservationValue={setIsOpenObservationValue}
          />
        }
      />

      {/* <div className="row">
        <div className="col-12">
          <AddObservationValue
            handleDocuments={handleDocuments}
            rowData={rowDataForObservation}
            onClose={onObservationValueClose}
            documentInfo={documentInfo}
            refetchBussinessReport={location.state?.refetchBussinessReport}
            isOpenObservationValue={true}
          />
        </div>
      </div> */}

      <div className="row">
        <div className="col-12">
          <AddObservationValueFullScreen
            handleDocuments={handleDocuments}
            rowData={location.state?.rowData || rowDataForObservation}
            onClose={onObservationValueClose}
            documentInfo={documentInfo}
            refetchBussinessReport={location.state?.refetchBussinessReport}
            isOpenObservationValue={true}
          />
        </div>
      </div>
    </div>
  );
};

export default AddObservationValuePage;
